import {
  AuthorizedApiService,
  BlobApiService,
} from "../../../services/apiServices";
import { notification } from "antd";
import {
  GET_OFFERS,
  GET_OFFER_BY_ID,
  SET_OFFER_TO_NULL,
  GET_YEARS,
  GET_OFFER_BY_OFFERNUMBER,
} from "./types";
import { NavigationPath } from "../../../helpers/constants";

export const getOffers =
  (supplierId = null, year = null) =>
  async (dispatch) => {
    try {
      const url = supplierId
        ? `offer/supplier/${supplierId}`
        : `offer/supplier`;
      AuthorizedApiService.get(url, {
        params: { year },
      })
        .then((res) => {
          const { status, data } = res;
          if (status !== 200) {
            notification.error({
              message: "Something went wrong,can not get offers!",
            });
            return;
          }
          const dataSorted = data.sort((a, b) => a.offerNumber - b.offerNumber);
          dispatch({
            type: GET_OFFERS,
            payload: dataSorted,
          });
        })
        .catch((err) => {
          console.log(err);
          notification.error({
            message: "Something went wrong,can not get offers!",
          });
        });
    } catch (error) {
      console.log(error);
    }
  };

export const deleteOffer = (ids) => async (dispatch) => {
  try {
    AuthorizedApiService.delete(`offer`, {
      data: { ids },
    })
      .then((res) => {
        const { status, data } = res;
        if (status !== 200) {
          notification.error({
            message: "Something went wrong!",
          });
          return;
        }
        notification.success({
          message: ids.length === 1 ? "Offer deleted!" : "Offers deleted!",
        });
        dispatch(getOffers());
      })
      .catch((err) => {
        notification.error({
          message: "Something went wrong!",
        });
      });
  } catch (error) {
    console.log(error);
  }
};

export const getOfferById = (id) => async (dispatch) => {
  try {
    dispatch({
      type: SET_OFFER_TO_NULL,
    });
    AuthorizedApiService.get(`offer/${id}`)
      .then((res) => {
        console.log(res);
        const { status, data } = res;
        if (status !== 200) {
          notification.error({
            message: "Something went wrong!",
          });
          return;
        }
        dispatch({
          type: GET_OFFER_BY_ID,
          payload: data,
        });
      })
      .catch((err) => {
        notification.error({
          message: "Something went wrong!",
        });
      });
  } catch (error) {
    console.log(error);
  }
};

export const updateOfferById = (offerToEdit, id) => async (dispatch) => {
  try {
    AuthorizedApiService.put(`offer/${id}`, offerToEdit)
      .then((res) => {
        const { status, data } = res;
        if (status !== 200) {
          notification.error({
            message: "Update error!",
          });
          return;
        }
        notification.success({
          message: "Update success!",
        });
        // window.location = NavigationPath.OFFERS_ROUTE;
      })
      .catch((err) => {
        console.log(err);
        notification.error({
          message: "Update error!",
        });
      });
  } catch (error) {
    console.log(error);
  }
};

export const getYearsForOffers = () => async (dispatch) => {
  try {
    AuthorizedApiService.get(`years-of-offers`)
      .then((res) => {
        const { status, data } = res;
        if (status !== 200) {
          return;
        }
        dispatch({
          type: GET_YEARS,
          payload: data,
        });
      })
      .catch((err) => {
        console.log(err);
        notification.error({
          message: "Something went wrong,can not get years for offers!",
        });
      });
  } catch (error) {
    console.log(error);
  }
};

export const sendOfferToEmail = (offerId, email) => async (dispatch) => {
  try {
    AuthorizedApiService.post("offer/send-email", { offerId, email })
      .then((res) => {
        console.log(res);
        const { status, data } = res;
        if (status !== 200) {
          notification.error({
            message: "Something went wrong",
          });
          return;
        }

        notification.success({
          message: `Offer sent to ${email}`,
        });
      })
      .catch((err) => {
        console.log(err);
        notification.error({
          message: "Something went wrong",
        });
      });
  } catch (error) {
    console.log(error);
    notification.error({
      message: "Something went wrong",
    });
  }
};

export const generatePdf = (offerNumber) => async (dispatch) => {
  try {
    BlobApiService.post("offer/send-pdf", { offerNumber })
      .then((res) => {
        const { status, data } = res;
        if (status !== 200) {
          notification.error({
            message: "Something went wrong",
          });
          return;
        }

        const url = window.URL.createObjectURL(new Blob([data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `ponuda_${offerNumber}.pdf`);
        document.body.appendChild(link);
        link.click();
        notification.success({
          message: `Offer downloaded`,
        });
      })
      .catch((err) => {
        console.log(err);
        notification.error({
          message: "Something went wrong",
        });
      });
  } catch (error) {
    console.log(error);
    notification.error({
      message: "Something went wrong",
    });
  }
};

export const getOfferByOfferNumber = (offerNumber) => async (dispatch) => {
  try {
    dispatch({
      type: SET_OFFER_TO_NULL,
    });
    AuthorizedApiService.get(`offer/${offerNumber}`)
      .then((res) => {
        console.log(res);
        const { status, data } = res;
        if (status !== 200) {
          notification.error({
            message: "Krivi broj ponude!",
          });
          return;
        }

        dispatch({
          type: GET_OFFER_BY_OFFERNUMBER,
          payload: data,
        });
      })
      .catch((err) => {
        notification.error({
          message: "Something went wrong!",
        });
      });
  } catch (error) {
    console.log(error);
  }
};

export const updateOfferStatusById = (status, offerId) => async (dispatch) => {
  try {
    AuthorizedApiService.put(`offer/status/${offerId}`, { status })
      .then((res) => {
        const { status, data } = res;
        console.log(res);
        if (status !== 200) {
          notification.error({
            message: "Update error!",
          });
          return;
        }
        dispatch(getOffers());
        notification.success({
          message: "Status updated!",
        });
      })
      .catch((err) => {
        console.log(err);
        notification.error({
          message: "Update error!",
        });
      });
  } catch (error) {
    console.log(error);
  }
};
